module.exports = __webpack_public_path__ + "img/banner.55f01a43.jpg";